import React from 'react';
import {useTranslation} from 'react-i18next';
import Information from '../../common/component/Information';

function TermsAndConditions() {

    //TODO
    const [t] = useTranslation();
    const text = (
        <>
            <p>Lorem ipsum dolor sit amet
                (<a href="https://albrechthof.de/impressum" target="_blank"> Lorem ipsum dolor sit amet</a>)
            </p>
            <h4>Lorem ipsum dolor sit amet</h4>
            <p>(Lorem ipsum dolor sit amet </p>

        </>);
    return (
        <Information header={t('General.TERMS_AND_CONDITIONS')} content={text}/>
    );
}

export default TermsAndConditions;
